// resources/js/utils/errorReporting.js
import { JS_ERRORS_ENDPOINT, sendJsErrorViaAxios } from "../api/jsErrorsHandling";

let listenersInitialized = false;

function buildPayload(payload = {}) {
    return {
        url: window.location?.href,
        user_agent: navigator.userAgent,
        time: new Date().toISOString(),
        ...payload,
    };
}

function fallbackSendWithBeaconOrFetch(body) {
    try {
        if (navigator.sendBeacon) {
            const blob = new Blob([body], { type: "application/json" });
            if (navigator.sendBeacon(JS_ERRORS_ENDPOINT, blob)) {
                return;
            }
        }
    } catch (err) {
        console.error("Error while sending beacon for error reporting:", err);
    }

    fetch(JS_ERRORS_ENDPOINT, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body,
        keepalive: true,
    }).catch((err) => {
        console.error("Error while sending error report (fetch fallback):", err);
    });
}

function sendErrorReport(payload = {}) {
    const data = buildPayload(payload);

    try {
        sendJsErrorViaAxios(data).catch((err) => {
            console.error("Error while sending JS error via axios:", err);

            const body = JSON.stringify(data);
            fallbackSendWithBeaconOrFetch(body);
        });
    } catch (err) {
        console.error("Unexpected error in sendErrorReport:", err);
        const body = JSON.stringify(data);
        fallbackSendWithBeaconOrFetch(body);
    }
}

function handleWindowError(event) {
    const message =
        event.error?.message || String(event.message || "Unknown error");

    sendErrorReport({
        type: "window",
        message,
        stack: event.error?.stack,
        source: event.filename,
        line: event.lineno,
        column: event.colno,
    });
}

function handleUnhandledRejection(event) {
    const reason = event.reason || {};
    const message =
        reason?.message ||
        String(event.reason || "Unhandled promise rejection");

    sendErrorReport({
        type: "unhandledrejection",
        message,
        stack: reason?.stack,
    });
}

export function initializeGlobalErrorReporting() {
    if (listenersInitialized || typeof window === "undefined") {
        return;
    }

    window.addEventListener("error", handleWindowError);
    window.addEventListener("unhandledrejection", handleUnhandledRejection);
    listenersInitialized = true;
}

export function attachVueErrorHandler(app, context = {}) {
    if (!app) return;

    const { componentName } = context;

    app.config.errorHandler = (error, instance, info) => {
        const component = instance?.type;
        const componentLabel =
            component?.name || component?.__file || componentName;

        sendErrorReport({
            type: "vue",
            message: error?.message || String(error || "Vue error"),
            stack: error?.stack,
            info,
            component: componentLabel,
        });

        console.error("Vue error captured", {
            error,
            info,
            component: componentLabel,
        });
    };
}

export default sendErrorReport;
